module.exports = __webpack_public_path__ + "img/client30.c711e277.png";